module.exports.CONTENTFUL_INDEX_PAGE_IDS = {
  accolades: '3F36dwPsht6g6geBqMEsB3',
  news: '43jJTUzlBaamDwaKfJcbZf',
  offices: '4DxFkZfT33O7CBkHSXBIQF',
  practiceAreas: '23hSKEtDWwHSV3Gjx8rCzU',
  professionals: '1WMCfztCvBPa3ywF0FjyRi',
  events: '1iNTN1YVOUMwz2QNZmudo3',
  insights: '5if9xKprWvNrUyyfWPk9vc',
}

module.exports.CONTENTFUL_CATEGORY_IDS = {
  accolades: '3poqqp7nKnOpBnfKOFFcNB',
  clientAlerts: '49Tz2Ucn8kEPrcBmlOZPDA',
  attorneyAuthored: '1EXSTN73HktYTgmdNO0ZkR',
  practiceAreas: '4RWtipGtOIDwOqo8dREliG',
  phFedAction: '6cbf066f-2334-6428-811c-ff00004cbded',
}

module.exports.CONTENTFUL_FILTER_PAGE_IDS = {
  covidResource: '44JvsoCVF4GRrOtBjJX9YL',
  tgb: '3Q7UT7rHBj8NdT5Ui1jtXe',
}

module.exports.CONTENTFUL_FILTER_PAGE_APPEARANCES = {
  ResourceCenter: 'Resource Center',
  Grid: 'Grid',
}

module.exports.CONTENTFUL_NAVIGATION_IDS = {
  header: '5E5hmBiP6umL9e1xYITHt0',
  footer: '7vHGXf4B1vjQxVJLssDIbf',
}

module.exports.CONTENTFUL_PAGE_IDS = {
  home: '26vOlLRKnKxlflWMQLQnXS',
  globalPrivacy: '3qrPxUziHF6kr0kMAWT1P8',
  termsAndConditions: '3Bt8L3oqNrHaUXdWzfbYxc',
  practiceAreas: '46SZriNQ0zr6wJdcJAXPVE',
  aboutUs: '5BQTVxUy0zShV95aaJwgk',
}

module.exports.CONTENTFUL_MODULE_IDS = {
  mediacContacts: '2mDVzuE4J7pYGN4rJMC4OG',
}
